/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * StripeCustomer情報の登録リクエスト
 * @export
 * @interface StripeCustomerRequestModel
 */
export interface StripeCustomerRequestModel {
    /**
     * 登録されたユーザーStripeのID
     * @type {string}
     * @memberof StripeCustomerRequestModel
     */
    stripeCustomerCd: string;
    /**
     * 登録されたユーザーのカードトークン
     * @type {string}
     * @memberof StripeCustomerRequestModel
     */
    cardToken: string;
    /**
     * 決済方法
     * * 1: "クレジットカード"
     * * 2: "アップルペイ"
     * * 4: "グーグルペイ"
     * @type {string}
     * @memberof StripeCustomerRequestModel
     */
    paymentType: StripeCustomerRequestModelPaymentTypeEnum;
}


/**
 * @export
 */
export const StripeCustomerRequestModelPaymentTypeEnum = {
    CREDIT_CARD: 'creditCard',
    APPLE_PAY: 'applePay',
    GOOGLE_PAY: 'googlePay'
} as const;
export type StripeCustomerRequestModelPaymentTypeEnum = typeof StripeCustomerRequestModelPaymentTypeEnum[keyof typeof StripeCustomerRequestModelPaymentTypeEnum];


/**
 * Check if a given object implements the StripeCustomerRequestModel interface.
 */
export function instanceOfStripeCustomerRequestModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stripeCustomerCd" in value;
    isInstance = isInstance && "cardToken" in value;
    isInstance = isInstance && "paymentType" in value;

    return isInstance;
}

export function StripeCustomerRequestModelFromJSON(json: any): StripeCustomerRequestModel {
    return StripeCustomerRequestModelFromJSONTyped(json, false);
}

export function StripeCustomerRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeCustomerRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stripeCustomerCd': json['stripeCustomerCd'],
        'cardToken': json['cardToken'],
        'paymentType': json['paymentType'],
    };
}

export function StripeCustomerRequestModelToJSON(value?: StripeCustomerRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stripeCustomerCd': value.stripeCustomerCd,
        'cardToken': value.cardToken,
        'paymentType': value.paymentType,
    };
}

